import { requestGet } from '@/utils/request';

const api = {
    LIST: '/statistics/stat_area_list'
};

export function statAreaList(params) {
    return requestGet(api.LIST, params);
}
